import _toConsumableArray from "/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["loop", "trapped", "onMountAutoFocus", "onUnmountAutoFocus"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useCallbackRef as e } from "@radix-ui/react-use-callback-ref";
import { Primitive as t } from "@radix-ui/react-primitive";
import { useComposedRefs as n } from "@radix-ui/react-compose-refs";
import * as o from "react";
import u from "@babel/runtime/helpers/esm/extends";
var c = {
  bubbles: !1,
  cancelable: !0
};
export var FocusScope = /*#__PURE__*/o.forwardRef(function (i, f) {
  var _i$loop = i.loop,
      l = _i$loop === void 0 ? !1 : _i$loop,
      _i$trapped = i.trapped,
      m = _i$trapped === void 0 ? !1 : _i$trapped,
      p = i.onMountAutoFocus,
      v = i.onUnmountAutoFocus,
      E = _objectWithoutProperties(i, _excluded),
      _o$useState = o.useState(null),
      _o$useState2 = _slicedToArray(_o$useState, 2),
      F = _o$useState2[0],
      S = _o$useState2[1],
      b = e(p),
      T = e(v),
      y = o.useRef(null),
      L = n(f, function (e) {
    return S(e);
  }),
      h = o.useRef({
    paused: !1,
    pause: function pause() {
      this.paused = !0;
    },
    resume: function resume() {
      this.paused = !1;
    }
  }).current;

  o.useEffect(function () {
    if (m) {
      var _e = function _e(e) {
        if (h.paused || !F) return;
        var t = e.target;
        F.contains(t) ? y.current = t : a(y.current, {
          select: !0
        });
      };

      var _t = function _t(e) {
        !h.paused && F && (F.contains(e.relatedTarget) || a(y.current, {
          select: !0
        }));
      };

      return document.addEventListener("focusin", _e), document.addEventListener("focusout", _t), function () {
        document.removeEventListener("focusin", _e), document.removeEventListener("focusout", _t);
      };
    }
  }, [m, F, h.paused]), o.useEffect(function () {
    if (F) {
      d.add(h);
      var _t2 = document.activeElement;

      if (!F.contains(_t2)) {
        var _n = new Event("focusScope.autoFocusOnMount", c);

        F.addEventListener("focusScope.autoFocusOnMount", b), F.dispatchEvent(_n), _n.defaultPrevented || (!function (e) {
          var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              _ref$select = _ref.select,
              t = _ref$select === void 0 ? !1 : _ref$select;

          var n = document.activeElement;

          var _iterator = _createForOfIteratorHelper(e),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _o = _step.value;
              if (a(_o, {
                select: t
              }), document.activeElement !== n) return;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }((e = r(F), e.filter(function (e) {
          return "A" !== e.tagName;
        })), {
          select: !0
        }), document.activeElement === _t2 && a(F));
      }

      return function () {
        F.removeEventListener("focusScope.autoFocusOnMount", b), setTimeout(function () {
          var e = new Event("focusScope.autoFocusOnUnmount", c);
          F.addEventListener("focusScope.autoFocusOnUnmount", T), F.dispatchEvent(e), e.defaultPrevented || a(null != _t2 ? _t2 : document.body, {
            select: !0
          }), F.removeEventListener("focusScope.autoFocusOnUnmount", T), d.remove(h);
        }, 0);
      };
    }

    var e;
  }, [F, b, T, h]);
  var N = o.useCallback(function (e) {
    if (!l && !m) return;
    if (h.paused) return;
    var t = "Tab" === e.key && !e.altKey && !e.ctrlKey && !e.metaKey,
        n = document.activeElement;

    if (t && n) {
      var _t3 = e.currentTarget,
          _ref2 = function (e) {
        var t = r(e),
            n = s(t, e),
            o = s(t.reverse(), e);
        return [n, o];
      }(_t3),
          _ref3 = _slicedToArray(_ref2, 2),
          _o2 = _ref3[0],
          _u = _ref3[1];

      _o2 && _u ? e.shiftKey || n !== _u ? e.shiftKey && n === _o2 && (e.preventDefault(), l && a(_u, {
        select: !0
      })) : (e.preventDefault(), l && a(_o2, {
        select: !0
      })) : n === _t3 && e.preventDefault();
    }
  }, [l, m, h.paused]);
  /*#__PURE__*/

  return o.createElement(t.div, u({
    tabIndex: -1
  }, E, {
    ref: L,
    onKeyDown: N
  }));
});
/*#__PURE__*/

function r(e) {
  var t = [],
      n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: function acceptNode(e) {
      var t = "INPUT" === e.tagName && "hidden" === e.type;
      return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });

  for (; n.nextNode();) {
    t.push(n.currentNode);
  }

  return t;
}

function s(e, t) {
  var _iterator2 = _createForOfIteratorHelper(e),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _n2 = _step2.value;
      if (!i(_n2, {
        upTo: t
      })) return _n2;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

function i(e, _ref4) {
  var t = _ref4.upTo;
  if ("hidden" === getComputedStyle(e).visibility) return !0;

  for (; e;) {
    if (void 0 !== t && e === t) return !1;
    if ("none" === getComputedStyle(e).display) return !0;
    e = e.parentElement;
  }

  return !1;
}

function a(e) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref5$select = _ref5.select,
      t = _ref5$select === void 0 ? !1 : _ref5$select;

  if (e && e.focus) {
    var _n3 = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== _n3 && function (e) {
      return e instanceof HTMLInputElement && "select" in e;
    }(e) && t && e.select();
  }
}

var d = function () {
  var e = [];
  return {
    add: function add(t) {
      var n = e[0];
      t !== n && (null == n || n.pause()), e = f(e, t), e.unshift(t);
    },
    remove: function remove(t) {
      var n;
      e = f(e, t), null === (n = e[0]) || void 0 === n || n.resume();
    }
  };
}();

function f(e, t) {
  var n = _toConsumableArray(e),
      o = n.indexOf(t);

  return -1 !== o && n.splice(o, 1), n;
}

export var Root = FocusScope;